var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19 11.97c0 .581-.24 1.08-.639 1.412l-8.943 8.229c-.64.582-1.597.499-2.076-.166s-.48-1.58.16-2.161l7.825-7.148c.08-.084.08-.167 0-.333L7.5 4.655a1.527 1.527 0 0 1-.08-2.161c.56-.582 1.438-.665 2.077-.167l8.943 8.146c.32.416.559.914.559 1.496"
  })));
};
export default SvgChevronRight;